/// <reference types="vite/client" />

import { lazy, Suspense, useEffect, useState } from "react";
import type {
	MapFit,
	MapPlace,
	MapPlacePreview,
	PlaceMapTranslations,
} from "./PlaceMap.types";
import { PlaceMapSkeleton } from "./PlaceMapSkeleton";

export type {
	MapFit,
	MapPlace,
	MapPlacePreview,
	PlaceMapTranslations,
} from "./PlaceMap.types";

const PlaceMapLeaflet = import.meta.env.SSR
	? null
	: lazy(() =>
			import("./PlaceMapLeaflet.client").then((m) => ({ default: m.PlaceMap })),
		);

type Props = {
	places: MapPlace[];
	activeId?: string | null;
	onPinClick?: (id: string | null) => void;
	curatorLogo?: string | null;
	fit?: MapFit;
	userPosition?: [number, number] | null;
	translations?: PlaceMapTranslations;
	loadPreview?: (place: MapPlace) => Promise<MapPlacePreview | null>;
};

export function PlaceMap(props: Props) {
	const [mounted, setMounted] = useState(false);

	useEffect(() => setMounted(true), []);

	if (!mounted || !PlaceMapLeaflet) return <PlaceMapSkeleton />;

	return (
		<Suspense fallback={<PlaceMapSkeleton />}>
			<PlaceMapLeaflet {...props} />
		</Suspense>
	);
}
